
import { Component, Vue } from 'vue-property-decorator';
import Header from './components/Header.vue';
import Aside from './components/Aside.vue';

@Component({
  name: 'MainLayout',
  components: {
    Header,
    Aside,
  },
})
export default class Main extends Vue {
}
